export enum LocalForageStores {
  Lens = "lens",
}

export enum LensStoreColumns {
  HiddenCellIds = "hiddenCellIds",
}

export enum UserSettings {
  SavedZoomScale = "savedZoomScale",
  SavedZoomOption = "savedZoomOption",
  SavedShowMetrics = "savedShowMetrics",
}
